


























// This component is typically used as a dynamic component inside ModalWrapperComponent

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { StoryUser } from '../StoryUser';
import { Story } from '../Story';
import { Question } from '../Question';
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import { RawLocation } from 'vue-router';
import { globalUC } from '../UserCache';
import AvatarComponent from '@/components/AvatarComponent.vue';           // @ is an alias to /src
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src

const DEBUGGING: boolean = true

interface selectOption { text?: string, html?: string, value: string, disabled?: boolean}

@Component({
  name: 'StoryStartFormComponent',
  components: { AvatarComponent, ModalWrapperComponent }
})
export default class StoryStartFormComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: 'Cancel' })
  public cancelBtnText: string

  // public reactive member variables available to the html template
  public title: string = null
  public circleUser: StoryUser = null
  public circleId: string = null
  public storyTellerId: string = null
  public storyTeller: StoryUser = null
  public startingTitle: string = null
  public storytellerOptions: selectOption[] = [ ]
  public questionId: string = null
  public hideQuestionPicker: boolean = false
  public fixedStoryTellerChoice: boolean = false
  public instantClosedDetection: boolean = false

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): StoryUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }
  public get storyTellerIsMe(): boolean { return this.userId === this.storyTellerId }
  public get okBtnText(): string { 
    if (this.storyTellerIsMe) {
      return 'Send me the Prompt'
    } else {
      return this.storyTeller ? `Send Prompt to ${this.storyTeller.firstName}` : 'Submit'
    }
  }

  public get titlePlaceHolder(): string {
    if (this.startingTitle) return this.startingTitle
    if (this.storyTeller && this.storyTellerIsMe && this.circleId !== this.storyTeller.circleId) return `Type a prompt or question about ${this.circleUser.firstName}`
    return 'Type a prompt or question'
  }
  public onCancel() {
    this.instantClosedDetection = true
    this.$emit('close', false)
  }
  public async onShow(dynamicProps: { circleUser?: StoryUser, circleId?: string, storyTellerId?: string, startingTitle?: string, hideQuestionPicker?: boolean }) {
    this.fixedStoryTellerChoice = dynamicProps && dynamicProps.storyTellerId != null
    this.circleUser = dynamicProps ? dynamicProps.circleUser : null
    this.circleId = dynamicProps ? dynamicProps.circleId : null
    this.storyTellerId = dynamicProps ? dynamicProps.storyTellerId : null
    this.startingTitle = dynamicProps ? dynamicProps.startingTitle : null
    this.hideQuestionPicker = dynamicProps ? dynamicProps.hideQuestionPicker : false

    this.fetchData()
  }

  // watched
  @Watch('storyTellerId')
  private async onStoryTellerIdChanged(val: string, oldVal: string) {
    this.storyTellerId = val
    if (this.storyTellerId && this.storyTellerId !== '*') {
      this.$store.commit('setLoading', { loading: true });
      this.storyTeller = await globalUC.get(this.storyTellerId, false)
      this.$store.commit('setLoading', { loading: false });
    } else {
      this.storyTeller = null
    }
  }

  public async onOK() {

    // tidy up form fields
    if (this.title) this.title = this.title.trim()

    // validate form fields
    let abort: boolean = false
    if (!this.storyTellerId || this.storyTellerId === '*') {
      abort = true
      utils.toast(this, 'Missing field', 'Please specify a story teller.')
    }
    if (!this.title || this.title.length === 0) {
      abort = true
      utils.toast(this, 'Missing field', 'Please enter a story prompt or question.')
    }
    

    if (abort) return

    // make POST call to server

    const stid: string = this.storyTellerId
    const cid: string = this.circleId || this.storyTeller.circleId
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = utils.getURLprefix() + '/api/stories'
      const response: any = await utils.makePostCall(url, { title: this.title, circleId: cid, storyTellerId: stid, isTutorial: false, questionId: this.questionId } );
      if (!response || !response.data) throw(new Error('StoryStartFormModalComponent.onOK() got null response or null response.data'))
      if (response.data.error) {
        this.$store.commit('setLoading', { loading: false });
        utils.toast(this, 'Error', response.data.error)
      }
      if (response.data.story) {
        // success
        this.$store.commit('setLoading', { loading: false });
        this.instantClosedDetection = true
        this.$emit('close', true)
      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Could not start story')
      if (this.$store.state.devmode) console.error(error);
    }

  }

  public suggest(): void {
    (this.$refs.ChooseQuestionComponent2 as ModalWrapperComponent).show('Choose a Question', 'lg', { storyTellerId: this.storyTeller ? this.storyTeller.getIdAsString() : this.storyTellerId })
  }

  // e.g. StoryStartFormComponent.onChooseQuestionModalShow(ChooseQuestionComponent, false, true)
  public async onChooseQuestionModalShow(componentName: string, modalShowing: boolean, chosenQuestion: Question) {
    if (DEBUGGING) console.log(`StoryStartFormComponent.onChooseQuestionModalShow(${componentName}, ${modalShowing}, ${chosenQuestion})`)
    if (!modalShowing && chosenQuestion) {
      this.questionId = chosenQuestion.id
      this.title = chosenQuestion.text
    }
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    // @ts-ignore: because segment analytics is loaded in head script
    window.analytics.page(this.$options.name)
  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

  private async fetchData(): Promise<void> {
    if (!this.user) return
    if (this.fixedStoryTellerChoice) return

    this.$store.commit('setLoading', { loading: true });
    try {
      const url: string = utils.getURLprefix() + `/api/users/${this.userId}/following`
      if (this.$store.state.devmode) console.log(`${this.$options.name} calling ${url}`)
      const response: any = await utils.makeGetCall(url);

      // error check
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }

      if (response.data.users) {
        let followingUsers: StoryUser[] = response.data.users.map((u) => new StoryUser(u))

        // sort following with most recordings at top
        followingUsers = followingUsers.sort((u1, u2) => u2.numRecordings - u1.numRecordings)

        if (this.$store.state.devmode) console.log(`${this.$options.name} got ${followingUsers.length} users that ${this.user.email} is following`)

        // create options
        this.storytellerOptions = []
        let atLeastOneFollowingHasPhoneNumber: boolean = false
        for (const fu of followingUsers) {
          let disabled: boolean = false
          let text: string = fu.getFullName()
          let value: string = fu.getIdAsString()
          if (!fu.phoneNumberIds || fu.phoneNumberIds.length === 0) {
            disabled = true
            text += ` (pending registration)`
            value = null
          } else {
            atLeastOneFollowingHasPhoneNumber = true
          }
          this.storytellerOptions.push({
            text,
            html: null,
            value,
            disabled
          })
        }
        if (!atLeastOneFollowingHasPhoneNumber) {
          this.storytellerOptions.unshift({
            text: 'You have no storytellers in your circle yet.',
            html: null,
            value: '*',
            disabled: false
          })
          // by default select first one
          if (!this.storyTeller) this.storyTellerId = '*'
        } else {
          // by default select first one
          if (followingUsers.length > 0) this.storyTellerId = followingUsers[0].getIdAsString()
        }
      }
    } catch (error) {
      utils.toast(this, 'Error', 'Could not load storytellers')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit('setLoading', { loading: false });
    }
  }

}
